export default __webpack_public_path__ + "static/Higgins-4558c73fde7f4300790a789f8e563ffe.jpg";